



















import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
@Component({
  components: {
  },
})
export default class NotFoundPage extends Vue {
  @Prop({}) pageTitle!: string;
}
